import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-plan" }
const _hoisted_2 = { class: "group-name" }
const _hoisted_3 = { class: "flex flex-row gap-4" }

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

import { maskCurrency } from "@/common/utils/mask";

import type { PlanType, PlanPayloadType } from "@/common/types/plan/plan";

import { baseInput, baseSelect, baseTextarea } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-plan',
  props: {
    data: {},
    isPatch: { type: Boolean },
    isEdit: { type: Boolean }
  },
  emits: ["update:data", "validate"],
  setup(__props: any, { emit: __emit }) {

const { t, tm } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
	stripe_product_id: "",
	name: "",
	status: "ACTIVE",
	free: false,
	description: null,
};

const payload = ref<PlanPayloadType>({ ...DEFAULT_DATA });
const errors = ref<{ [key: string]: string }>({});

const statusOptions = computed(() => [
	{ option: t("common.labels.active"), value: "ACTIVE" },
	{ option: t("common.labels.inactive"), value: "INACTIVE" },
]);

const freeOptions = computed(() => [
	{ option: t("common.labels.yes"), value: true },
	{ option: t("common.labels.not"), value: false },
]);

function validate() {
	const free = ["stripe_product_id", "name", "status"];

	Object.keys(payload.value).forEach((key) => {
		delete errors.value[key];

		if (!payload.value[key] && !free.includes(key))
			errors.value[key] = t("error.required");
	});

	emit("validate", Object.keys(errors.value).length === 0);
}

function update(key: keyof typeof payload.value) {
	validate();

	if (props.isPatch) {
		if (payload.value[key] === props.data[key]) return;

		emit("update:data", { [key]: payload.value[key] });
		return;
	}

	emit("update:data", payload.value);
}

function resumeData() {
	if (!props.data) return;

	const { stripe_product_id, name, status, free, description } = props.data;

	payload.value = {
		...payload.value,
		stripe_product_id,
		name,
		status,
		free,
		description,
	};
}

watch(
	() => props.data,
	() => {
		resumeData();
	},
	{ immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
        value: payload.value.name,
        placeholder: _unref(t)('common.placeholders.name'),
        required: "",
        maxlength: "75",
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (update('name')))
      }, _createSlots({
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
        ]),
        _: 2
      }, [
        (errors.value.name)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.name), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.status) = $event)),
        value: payload.value.status,
        options: statusOptions.value,
        "is-empty": false,
        onChange: _cache[3] || (_cache[3] = ($event: any) => (update('status')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.status")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.stripe_product_id,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.stripe_product_id) = $event)),
        value: payload.value.stripe_product_id,
        onBlur: _cache[5] || (_cache[5] = ($event: any) => (update('stripe_product_id')))
      }, _createSlots({
        label: _withCtx(() => [
          _cache[10] || (_cache[10] = _createTextVNode(" Stripe Produto ID *", -1))
        ]),
        _: 2
      }, [
        (errors.value.stripe_product_id)
          ? {
              name: "error",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(errors.value.stripe_product_id), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "value"]),
      _createVNode(_unref(baseSelect), {
        modelValue: payload.value.free,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payload.value.free) = $event)),
        value: payload.value.free,
        options: freeOptions.value,
        "is-empty": false,
        onChange: _cache[7] || (_cache[7] = ($event: any) => (update('free')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.free")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"])
    ]),
    _createVNode(_unref(baseTextarea), {
      modelValue: payload.value.description,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((payload.value.description) = $event)),
      value: payload.value.description,
      rows: 5,
      onBlur: _cache[9] || (_cache[9] = ($event: any) => (update('description')))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value"])
  ]))
}
}

})